import useLoggedOrRedirect from 'hooks/routing/useLoggedOrRedirect';
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function ProtectedPages() {
  useLoggedOrRedirect();

  return <Outlet />;
}
